<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable  placeholder="全部">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.coverImg"
                            :lazy="true"
                            :preview-src-list="[scope.row.coverImg]"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="系列课名称" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="suitCrowd"
                    label="适合人群" >
                </el-table-column>
                <el-table-column
                    prop="lessonCount"
                    min-width="120"
                    label="课程数" >
                </el-table-column>
                <el-table-column
                    prop="typeName"
                    min-width="120"
                    label="类型" >
                </el-table-column>
                <el-table-column
                    min-width="200"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray" size="mini" ></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button type="primary" @click="show(scope.row)" size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>



    import {mapMutations} from "vuex";

    export default {
        components: {
        },
        props: [
            "attr"
        ],
        data() {
            return {

                form: {
                    keywords: "",
                    enable: null,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [ ],
                lessonTypes: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            ...mapMutations(["openTab"]),

            loadData() {
                this.$ajaxPost("/lessonSystem/listSelfClassSystems", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                    this.showAdd = false;
                })
            },
            show(item) {
                this.openTab({
                    funcKey: "school_page_lessonsytem_detail",
                    title: item.name + "详情",
                    allowDuplicate: true,
                    attr: {
                        lessonSystem: item
                    }
                });
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },

        },

        created() {
            this.loadData();
            this.loadLessonTypes();
        }

    }
</script>
